import React, { useState } from 'react';
import { App, Divider, Flex, Input, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { useLocation } from 'react-router';

import { IProducts } from '../service/products.interface';
import { HeaderScenarios } from '../../../../communities/components/HeaderScenarios/HeaderScenarios';
import { DescriptionEditor } from '../../../../courses/components/Author/components/DescriptionEditor';
import { ProductUploader } from '../../../../courses/components/Author/components/ProductUploader';
import { OldPrice } from './OldPrice';
import { BuyableSwitcher } from '../../../../courses/components/Author/components/BuyableSwitcher';
import { ProductStatusSwitcher } from './ProductStatusSwitcher';
import { ProductCategoriesSelector } from '../../categories/components/ProductCategoriesSelector';
import { Price } from '../../../../courses/components/Author/containers/post/components/Price';
import { Save } from '../../../widgets/Save';

const inputSize = 260;

interface Props {
    readonly onSave: (values: IProducts) => Promise<void>;
    readonly initialValues: IProducts;
    readonly loading?: boolean;
    readonly isDisableEditProduct?: boolean;
}
export const ProductForm = ({
    onSave,
    loading,
    initialValues,
    isDisableEditProduct,
}: Props) => {
    const { pathname } = useLocation();
    const { type } = useParams();
    const { notification } = App.useApp();
    const navigate = useNavigate();
    const location = useLocation();
    const isLinkPage = /\/links-create$|\/links-edit\//.test(location.pathname);

    const [loadingDeleteImage, setLoadingDeleteImage] = useState(false);
    const [blurredName, setBlurredName] = useState('');

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSave,
    });

    const isEdit = pathname.includes('edit');

    const onChange = (value: string) => {
        if (value.match(/^[ ]+$/)) {
            return notification.error({
                message: 'Название товара обязательно для заполнения',
            });
        }

        if (value.length > 100) {
            return notification.error({
                message: 'Название товара не может быть длиннее 100 символов',
            });
        }

        if (value.length === 0) {
            formik.setFieldValue('title', value);
        } else formik.setFieldValue('title', value);
    };

    const handlerClearTitle = () => {
        formik.setFieldValue('title', '');
    };

    const renderTitle = (type: string) => {
        switch (type) {
            case 'products':
                return 'Товар';
            case 'links':
                return 'Витрина';
            case 'product-order':
                return 'Заявка';
            default:
                return 'Товар';
        }
    };

    const getBlurText = text => {
        setBlurredName(text);
    };

    return (
        <Flex vertical gap={'middle'}>
            <Flex vertical gap={8}>
                <Typography.Title
                    level={1}
                    style={{ margin: 0, marginBottom: '0' }}
                >
                    {renderTitle(type)}
                </Typography.Title>

                {type === 'product-order' && (
                    <Typography.Text>
                        Дает возможность оставить клиенту заявку на
                        индивидуальный товар. При оформлении заявки покупатель
                        указывает имя, телефон и почту для связи. Этот товар
                        нельзя добавить в корзину, а так же купить через
                        магазин. Отображение цены всегда “от”.
                    </Typography.Text>
                )}
            </Flex>

            <HeaderScenarios
                goBack={() => navigate(-1)}
                inputValue={formik?.values?.title || ''}
                onChangeHeaderInput={({ target }) => {
                    onChange(target.value);
                }}
                tooltip={formik?.values.title}
                onExtraEdit={!isEdit ? handlerClearTitle : null}
                withoutEdit={isDisableEditProduct}
            />

            {type === 'links' && (
                <Flex gap={16} style={{ maxWidth: '578px' }} vertical>
                    <Divider style={{ margin: 0 }} />
                    <Flex gap={8} vertical>
                        <Typography.Text>Ссылка на товар</Typography.Text>
                        <Input
                            value={formik?.values?.link}
                            placeholder='Укажите ссылку'
                            onChange={event => {
                                formik.setFieldValue(
                                    `link`,
                                    event.target.value
                                );
                            }}
                        />
                    </Flex>
                </Flex>
            )}

            <DescriptionEditor
                onBlur={getBlurText}
                formik={formik}
                isDisabled={isDisableEditProduct}
            />

            {/* <AiImageGenerator
                mainButtonText={'Выбрать фото'}
                paramName={'image_urls'}
                text={blurredName}
                formik={formik}
            />*/}
            <ProductUploader
                loadingDeleteImage={loadingDeleteImage}
                setLoadingDeleteImage={setLoadingDeleteImage}
                isEdit={isEdit}
                formik={formik}
                type={'images'}
                isDisabled={isDisableEditProduct}
                blurredName={blurredName}
            />

            <Price
                formik={formik}
                width={inputSize}
                type={type}
                isDisabled={isDisableEditProduct}
            />

            {type === 'links' ||
                (type === 'products' && (
                    <OldPrice
                        formik={formik}
                        width={inputSize}
                        isDisabled={isDisableEditProduct}
                    />
                ))}

            {type === 'products' && (
                <BuyableSwitcher
                    formik={formik}
                    width={inputSize}
                    isDisabled={isDisableEditProduct}
                />
            )}

            <ProductStatusSwitcher
                formik={formik}
                width={inputSize}
                isDisabled={isDisableEditProduct}
            />

            <Flex gap={8} vertical>
                <Typography.Text>Категория товара</Typography.Text>
                <ProductCategoriesSelector
                    formik={formik}
                    width={inputSize}
                    isDisabled={isDisableEditProduct}
                />
            </Flex>

            <Save onSave={() => formik.submitForm()} disabled={loading} />
        </Flex>
    );
};
